<template>
  <div id="top-header">

    <dv-decoration-2 style="width:500px;height:7px;position: absolute;bottom: 0;left: 0"
                     :color="['#3C8F6C','#60FCB2']"/>
    <dv-decoration-2 style="width:500px;height:7px;position: absolute;bottom: 0;right: 0"
                     :color="['#3C8F6C','#60FCB2']"/>
    <div class="background"></div>

    <div class="left-title flex-row--c" style="z-index:5400">
      <el-dropdown @click="change_shengqu">
        <div class="select flex-row--c">
          <i class="saasIcon">&#xe61a;</i>
          <span>{{ shengqu_board_info.shengqu_name }}</span>
          <i class="saasIcon">&#xe65c;</i>
        </div>
        <el-dropdown-menu slot="dropdown" :append-to-body=false style="z-index:5400;width: 600px">
          <el-dropdown-item @click.native="change_shengqu(item)" v-for="item in options_province"
                            class="sort-item"
                            :key="item.value">
            <span v-text="item.value"></span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="temperature flex-row--c">
        <img src="~@/assets/large/yun.png" alt="">
        <span>{{ shengqu_board_info.avg_1w_temp }}℃</span>
      </div>
    </div>

    <div class="center-title flex-row-c-c">春播万象 智慧数据</div>

    <div class="right-title flex-row--c">

      <span class="span-1">最常见疾病：{{ shengqu_board_info.most_freq_dis }}</span>
      <span class="span-2">整体趋势：{{ shengqu_board_info.overall_dis_level }}</span>
    </div>


  </div>
</template>

<script>

export default {
  name: "TopHeader",
  components: {},
  data() {
    return {
      options_province: null,
      currentDate: "",
      time: null,
      shengqu_board_info: {
        shengqu_name: '北京',
        avg_1w_temp: '20.0',
        most_freq_dis: '咳嗽',
        overall_dis_level: '中等',
      },
    };
  },
  mounted() {
    this.get_province();
    this.change_shengqu({"value": "北京"})
  },
  created() {
    this.time = setInterval(() => {
      this.currentDate = this.$utils.getDate();
    }, 1000);
  },
  destroyed() {
    clearInterval(this.time);
  },
  methods: {
    get_province() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_shengqu").then((res) => {
        this.options_province = res.data.data.filter(item => item.value != '')
      })
    },
    change_shengqu(item) {
      this.$http.post(process.env.VUE_APP_API_HOST + "/get_shengqu_board",
          {"shengqu": item.value}, {"content-type": "application/json"}).then((res) => {
        this.shengqu_board_info = res.data.data
      })
    },
  }
};
</script>

<style lang="less" scoped>

/* 设置选项样式 */
.sort-item {
  display: inline-block;
  min-width: 110px;
  max-width: 200px;
  padding: 0 3px;
  margin: 10px 12px 2px 0;
  border-radius: 16px;
  line-height: 32px;
  font-size: 14px;
  color: #333333;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.04);
  cursor: pointer;
}

#top-header {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  height: 82px;
  align-items: center;
  padding: 0 50px;


  .background {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(270deg,
    #74ffbe 0%,
    rgba(116, 255, 190, 0) 33%,
    rgba(116, 255, 190, 0) 66%,
    #74ffbe 100%);
    opacity: 0.15;
    z-index: 0;
  }

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 30px;
  }

  .header-left-decoration,
  .header-right-decoration {
    margin-top: 20px;
    width: 25%;
    height: 60px;
  }

  .right-title,
  .left-title,
  .center-title {
    z-index: 2;
  }

  .left-title,
  .right-title {
    font-size: 25px;
    color: #70a7df;
  }

  .left-title {
    color: #FFFFFF;

    .el-dropdown {

      .select {
        cursor: pointer;
        color: #FFFFFF;

        span {
          font-size: 20px;
          font-weight: bold;
          padding: 0 5px;
        }

        .saasIcon {
          font-size: 24px;
        }

      }

    }

    .temperature {
      margin-left: 50px;

      img {
        width: 24px;
      }

      span {
        font-size: 22px;
        padding-left: 10px;
      }

    }
  }

  .right-title {
    font-size: 24px;
    font-weight: bold;


    span {
      position: relative;
      color: #FFFFFF;

      &:before {
        content: '';
        width: 9px;
        height: 36px;
        background: #FCAE60;
        position: absolute;
        top: 0;
        border-radius: 0px 9px 9px 0px;
        left: -16px;
      }

      &.span-2 {
        margin-left: 90px;
      }
    }
  }

  .center-title {
    margin-left: 180px;
    font-weight: 600;
    width: 30%;
    font-size: 32px;
    height: 100%;
    letter-spacing: 3px;
    background: url("~@/assets/large/top-center.png");
    background-size: 100% 100%;
  }

  .center-decoration {
    width: 100%;
    position: absolute;
    top: 60px;
    padding: 0 220px;
    // left: 11%;
    // transform: translateX(-50%);
  }
}
</style>
